var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-boxes"},_vm._l((_vm.stats),function(stat,index){return _c('StatBox',{directives:[{name:"loading",rawName:"v-loading",value:(stat.loading),expression:"stat.loading"}],key:index,attrs:{"stat":stat}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }